import ClientDocumentsApi from '../../../../services/api/clientDocumentsApi';

/* Service class used to perform api calls for the Client Document Management service */
class DoxUploaderCDMService {

    /**
     * Handles uploading of the file to the backend
     * @param {Function} handleUnauthorized injected method to handle 401 errors
     * @param {string|number} taxYear tax year for this file
     * @param {File} file the file object to upload
     * @param {Function} onUploadProgress callback function to track upload progress
     * @param {object} cancellationToken cancellation token for cancelling the upload.
     * @param {string|null} newFileName optional parameter for renaming the file on upload.
     */
    async uploadFile(handleUnauthorized, taxYear, file, onUploadProgress, cancellationToken, newFileName) {
      
        let formData = new FormData();

        formData.append("taxYear", taxYear);

        // only set new name if it isn't null. otherwise, this will rename the file to 'null'
        // I LEARNED THIS THE HARD WAY SO YOU DON'T HAVE TO.
        if (newFileName) {
            formData.append("file", file, newFileName)
        } else {
            formData.append("file", file)
        }
        
        let config = {
            onUploadProgress: onUploadProgress,
            cancelToken: cancellationToken
        }

        return ClientDocumentsApi.create(handleUnauthorized).uploadDocument(formData, config);
    }
}

const doxUploaderCDMService = new DoxUploaderCDMService();
export default doxUploaderCDMService;